
import Button from '@/components/UntitledUI/Button.vue'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    name: 'FileUploadInput',
    components: {
        Button, Icon
    },
    props: {
        value: {
            type: null,
            default: null
        },
        error: {
            type: String,
            default: null
        },
        accept: {
            type: String,
            default: '*'
        }
    },
    data () {
        return {
            dragged: false,
            fileName: ''
        }
    },
    watch: {
        value () {
            if (this.value instanceof File) {
                this.fileName = this.value.name
            } else {
                this.$refs.uploader.value = ''
            }
        }
    },
    methods: {
        handleFile (e) {
            if (e.target.files) {
                const file = e.target.files[0]

                if (file) {
                    return this.$emit('input', file)
                }
                return
            }

            if (e.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                [...e.dataTransfer.items].forEach((item, i) => {
                    // If dropped items aren't files, reject them
                    if (item.kind === 'file') {
                        const file = item.getAsFile()
                        this.$emit('input', file)
                    }
                })
            } else {
                // Use DataTransfer interface to access the file(s)
                [...e.dataTransfer.files].forEach((file, i) => {
                    this.$emit('input', file)
                })
            }
        },
        dropHandler (e) {
            e.preventDefault()

            this.handleFile(e)

            this.dragged = false
        },
        dragOverHandler (e) {
            // Prevent default behavior (Prevent file from being opened)
            e.preventDefault()

            this.dragged = true
        },
        dragLeaveHandler (e) {
            this.dragged = false
        },
        removeFile (e) {
            e.preventDefault()
            e.stopImmediatePropagation()

            this.$emit('input', null)
        }
    }
}
